<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jxky/home">教学科研</router-link> >
      <router-link to="/jxky/byhyxjy">毕业后医学教育</router-link> >
      <router-link to="/jxky/professional">专业基地</router-link> >
      {{ current.keyword }}
    </div>
    <div class="container-width">
      <div class="list">
        <div class="j-item"><span>基地简介</span></div>
        <div v-html="current.description" class="j-description"></div>
      </div>
      <div class="list">
        <div class="j-item"><span>师资力量</span></div>
        <div v-html="current.teachings" class="j-description"></div>
      </div>
      <div class="list">
        <div class="j-item"><span>特色培训</span></div>
        <div v-html="current.feature" class="j-description"></div>
      </div>
      <div class="list">
        <div class="j-item"><span>成果及荣誉</span></div>
        <div v-html="current.honors" class="j-description"></div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/jxky";
import BANNER from "../../components/banner/jxky";
import { jxkyNavDic } from "../../const/navigationData";
export default {
  name: "PROFESSIONALARTICLE",
  data() {
    return {
      navigationData: jxkyNavDic,
      currentPath: "/jxky/byhyxjy",
      current: {},
    };
  },
  components: {
    BANNER,
  },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      let data = {
        id: this.$route.params.id,
      };
      service.getOneProfessionalBase(data, (res) => {
        this.current = res.object || {};
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style scoped lang="scss">
.list {
  margin-top: 30px;
  .j-item {
    border-bottom: 1px solid #00479d;
    span {
      display: inline-block;
      padding: 0 60px;
      background: #00479d;
      color: #fff;
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
  }
  .j-description {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 1.1rem;
    line-height: 40px;
    color: #333;
  }
}
@media only screen and (max-width: 728px) {
  .list {
    .j-item {
      span {
        padding: 0 30px;
      }
      .j-description {
        line-height: 25px;
      }
    }
  }
}
</style>
